import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';
require('jquery-validation');

Snappy.Component.Footer = class Footer extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-footer';
	}
	
	constructor(element) {
		super(element);
	}
	
	setVars() {
		this.$newsletterForm = this.$element.find('.fa-footer__newsletter__form');
		this.$socialSelect = this.$element.find('.fa-dropdown__select');
		this.$newsletterResponseTemplate = $('#newsletter-response-template');
		this.activeClass = 'active';
		this.inactiveClass = 'inactive';
		this.submittedClass = 'submitted';
		this.errorClass = 'fa-input-field--error';
		this.messageClass = 'fa-input-field__error-message';
	}
	
	setEventListeners() {
		this.$socialSelect.on('change', this.onSocialSelectChange.bind(this));
		this.$newsletterForm.on('submit', this.validateNewsletterForm.bind(this));
		
		if (this.$newsletterForm.length) {
			this.$window.on('modal:modalHasOpened', this.setNewsletterEventListeners.bind(this));
		}
	}
	
	setNewsletterEventListeners(event, modal) {
		modal.$element.find('.fa-footer__modal-form').on('submit', this.submitNewsletterSignup.bind(this, modal));
	}

	validateNewsletterForm(event) {
		const $emailField = this.$newsletterForm.find('input[type=email]');
		this.$newsletterForm.validate({
			rules: {
				'Email': {
					required: true,
					email: true
				}
			}
		});
		
		if ($emailField.valid()) {
			this.openNewsletterModal();
		} else {
			$emailField.focus();
		}
		
		event.preventDefault();
	}
	
	handleValidationResponse(response) {
		if (response.success) {
			this.removeValidationError(response);
			this.openNewsletterModal();
		} else {
			this.showValidationError(response);
		}
	}
	
	showValidationError(response) {
		const $element = $(`#${response.element}`);
		
		$element
			.addClass(this.errorClass)
			.parent()
			.addClass(this.errorClass)
			.find(`.${this.messageClass}`).text(response.message);
	}
		
	removeValidationError(response) {
		const $element = $(`#${response.element}`);
		
		$element
			.removeClass(this.errorClass)
			.parent('[data-fa-input-field]')
			.removeClass(this.errorClass)
			.find(`.${this.messageClass}`).text('');
	}
		
	submitNewsletterSignup(modal, event) {
		const url = modal.$element.find('.fa-footer__modal-form').attr('action');
		const emailAddress = this.$newsletterForm.find('input[type=email]').val();
		const categories = modal.$element.find('input:checked').map((i, el) => el.value).get().join();
		event.preventDefault();
		$.ajax({
			"url": url,
			"type": "post",
			"data": {
				"emailAddress": emailAddress,
				"categories": categories
			}
		})
		.always(this.handleNewsletterResponse.bind(this, modal));
	}
	
	handleNewsletterResponse(modal, response) {
		const template = this.getNewsletterResponseTemplate();
		const responseHtml = template(response);
		const $error = $('.fa-footer__newsletter__modal-content').children(`.${this.messageClass}`);
		
		if (response.success) {
			this.closeNewsletterModal(modal);
			this.$newsletterForm
				.addClass(this.submittedClass)
				.after(responseHtml);
		} else {
			$error
				.text(response.message)
				.addClass(this.activeClass);
			$error[0].focus();
		}
	}
	
	getNewsletterResponseTemplate() {
		let template;
		
		if (this.$newsletterResponseTemplate) {
			template = Handlebars.compile(this.$newsletterResponseTemplate.html());
		}
		
		return template;
	}

	openNewsletterModal() {
		const $button = this.$newsletterForm.find('button');
		this.$window.trigger('modal:openModal', {
			$view: $($button.data('modal-template')),
			title: $button.data('modal-title'),
			$prevElement: $button
		});
	}
	
	closeNewsletterModal(modal) {
		modal.closeModal();
	}
	
	hideSocialChannels() {
		this.$element.find('.fa-footer__social-channels__channel').addClass(this.inactiveClass);
	}
	
	onSocialSelectChange(event) {
		const section = event && event.currentTarget && event.currentTarget.value;
		if (section) {
			this.hideSocialChannels();
			this.$element.find('[data-social-section="' + section + '"]').removeClass(this.inactiveClass);
		}
	}
	
	render() {
		this.setVars();
		this.setEventListeners();
		this.onSocialSelectChange({
			currentTarget: {
				value: this.$socialSelect.val()
			}
		});
	}
};



// WEBPACK FOOTER //
// ./components/footer/scripts/footer.js